// extracted by mini-css-extract-plugin
module.exports = {"c1dk030q":"c1dk030q","l18ymu56":"l18ymu56"};